import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { recomendaciones } from "../data/recomendaciones";

const RecomendacionDetalle = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const recomendacion = recomendaciones.find(e => e.slug === slug);
  if (!recomendacion) return <p>Evento no encontrado</p>;

  return (
    <section className="section">
      <div className="container">
        <button onClick={() => navigate(-1)} className="form-button" style={{ marginBottom: "1.5rem" }}>
          ← Volver
        </button>

        <figure className="section-image-wrapper">
        <img src={recomendacion.imagen} alt={recomendacion.titulo} className="section-image" />
          {recomendacion.epigrafe && (
            <figcaption className="section-image-caption">{recomendacion.epigrafe}</figcaption>
          )}
        </figure>
        <h2 className="section-title">{recomendacion.titulo}</h2>
        <p className="contact-heading">{recomendacion.descripcionCorta}</p>

        <div className="taller-detalle-texto">
          {recomendacion.descripcionLarga.split(/\n\s*\n/).map((parrafo, i) => (
          <p key={i}>{parrafo}</p>
        ))}
        </div>
        {recomendacion.imagenesExtra?.length > 0 && (
        <div className="evento-galeria">
          {recomendacion.imagenesExtra.map((src, i) => (
            <img key={i} src={src} alt={`Imagen extra ${i}`} className="evento-img" />
          ))}
        </div>
      )}
      </div>
    </section>
  );
};

export default RecomendacionDetalle;
